import {
    Action,
    StoreEnhancer,
} from '@reduxjs/toolkit'
import {
    changeIdle,
    changeVisibility,
} from '../../actions/app'

export const idleEnhancer: StoreEnhancer = (createStore) => (...args) => {
    const store = createStore(...args)

    const IDLE_TIMEOUT_IN_SECONDS = 60

    let isIdle = false
    let isActive = true

    let idleTimeoutId: ReturnType<typeof setTimeout> // eslint-disable-line init-declarations

    const dispatch = (action: Action, shouldIdle: boolean) => {
        isIdle = shouldIdle
        store.dispatch(action as any)
    }

    const onIdle = () => {
        isActive = false
        dispatch(changeIdle(true), true)
    }

    const startIdleTimeout = () => {
        idleTimeoutId = setTimeout(onIdle, IDLE_TIMEOUT_IN_SECONDS * 1000)
    }

    const onActivity = () => {
        clearTimeout(idleTimeoutId)
        startIdleTimeout()

        if (isIdle || !isActive) {
            isActive = true
            dispatch(changeIdle(false), false)
        }
    }

    const onVisibilityChange = () => {
        const isVisible = document.visibilityState === 'visible'

        dispatch(changeVisibility(isVisible), !isVisible)

        if (isVisible) {
            clearTimeout(idleTimeoutId)
            startIdleTimeout()
        }
    }

    // Idle Detection API alternative
    ['keydown', 'mousedown', 'mousemove', 'touchmove', 'touchstart', 'wheel'].forEach((type) => {
        document.addEventListener(type, onActivity)
    })

    // Page Visibility API
    document.addEventListener('visibilitychange', onVisibilityChange)

    startIdleTimeout()

    return store
}
